<template>
  <div>
    <barra-de-filtro v-model="filtros" class="align-center" style="height: 52px" />

    <v-divider />

    <tabela-produtos :filtros="filtros" />
  </div>
</template>

<script>
import BarraDeFiltro from "./BarraDeFiltro";
import TabelaProdutos from "./TabelaProdutos";
import DrpAPI from "@/api/drp";
import { logout } from "@/helpers";

export default {
  name: "Index",
  components: { TabelaProdutos, BarraDeFiltro },
  data: () => ({
    filtros: {
      grupo: 0,
      filial: [],
      segmentos: [],
      fornecedores: []
    }
  }),
  created() {
    this.buscarGrupos();
  },
  methods: {
    buscarGrupos() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getGruposDrp(headers, { ativar_drp: 'S' })
        .then((response) => {
          const { token, grupos } = response.data;
          localStorage.setItem("token", token);

          if (grupos.length > 0) {
            this.filtros.grupo = grupos[0].id;
          }
        })
        .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
